/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateValueValidationModel
 */
export interface DateValueValidationModel {
    /**
     * 
     * @type {boolean}
     * @memberof DateValueValidationModel
     */
    beforeToday?: boolean;
}

/**
 * Check if a given object implements the DateValueValidationModel interface.
 */
export function instanceOfDateValueValidationModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DateValueValidationModelFromJSON(json: any): DateValueValidationModel {
    return DateValueValidationModelFromJSONTyped(json, false);
}

export function DateValueValidationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateValueValidationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'beforeToday': !exists(json, 'beforeToday') ? undefined : json['beforeToday'],
    };
}

export function DateValueValidationModelToJSON(value?: DateValueValidationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'beforeToday': value.beforeToday,
    };
}

